<template>
    <div class="container">
        <div class="content">
            <img src="../../../assets/images/group-logo-white.svg" alt="Navitas Group">
            <h5>We're currently completing essential updates to the platform. </h5>
            <h5>We apologise for any inconvenience this may cause.</h5>
            <h5>Please try accessing the system again in a few moments.</h5>
        </div>
    </div>
</template>

<script>

export default {
    name: "MaintenanceModeDashboard",
    mounted() {
        this.$api.version().then(() => {
            this.$router.push(this.$enums.RoutePathEnum.DASHBOARD)
            }
        )
    }
}
</script>

<style scoped lang="scss">

@import "../../../old/scss/variables";

.container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: url("~@/assets/images/login.jpg") no-repeat center center fixed;
    background-size: cover;

    .content {
        margin-top: 64px;
        padding: 36px;
        border-radius: $s-border-radius;
        background-color: $bg-color;
        color: $text-color;
        text-align: center;
        img {
            width: 290px;
            margin-bottom: 18px;
        }
        h5 {
            font-weight: 400;
        }
    }
}
</style>